/* method to get the container width minus padding and other stuff that takes up space
    - if the container has a max width limit, truncate the text even if there is more space available
   */
export const getAvailableWidth = (
  containerEl: HTMLElement,
  padding: number,
  widthOfWidestLetter: number,
  suffixEl?: HTMLElement,
  forceWidth?: number,
  maxWidth?: number,
  minWidth?: number
) => {
  const suffixWidth = suffixEl?.clientWidth ?? 0;

  const clientWidth = containerEl
    ? Math.floor(containerEl.getBoundingClientRect().width)
    : 0;

  /** TODO: the suffix should only take up the width of the last line */
  const containerWidth =
    forceWidth > 0
      ? forceWidth
      : Math.min(Math.max(minWidth ?? 0, clientWidth), maxWidth ?? clientWidth);

  return Math.floor(
    containerWidth - padding - suffixWidth - widthOfWidestLetter
  );
};
